import path from 'path'
import store from '../store/store'

export default {
    name: 'Global',
    methods: {
        generateDataPath: function (resouce, params = {}) {
            this.data_dir = process.env.VUE_APP_DATA_DIR
            const query = new URLSearchParams(params)

            const buttondataUrl = path.resolve(this.data_dir, 'data', `${resouce}?${query}`)

            return buttondataUrl
        },
        _newItemsObj: function (videoId) {
            let splitedItemsInfo = store.getVideoInfos()[videoId]
            if (splitedItemsInfo == null) {
                splitedItemsInfo = {
                    title: '',
                    urls: [],
                    items: [],
                }
            }

            const newItems = {
                key: videoId,
                title: splitedItemsInfo.title,
                urls: splitedItemsInfo.urls,
                items: [],
            }

            return newItems
        },
        splitArrayByKey: function (items, key) {
            const map = new Map()
            for (const item of items) {
                let keyval = item[key]
                if (keyval == null) {
                    keyval = 'default'
                }
                let spliteditemsobj = {}
                if (map.has(keyval)) {
                    spliteditemsobj = map.get(keyval)
                } else {
                    spliteditemsobj = this._newItemsObj(item[key])
                }
                const spliteditems = spliteditemsobj.items
                spliteditems.push(item)
                spliteditemsobj.items = spliteditems
                map.set(keyval, spliteditemsobj)
            }
            return Array.from(map.values())
        },
    }
}
